// helpers.
const status = ['Pendiente', 'Concluido', 'Atrasado']

// main function.
const auditStatusFormat = (num) => {
  return status[num]
}

export default auditStatusFormat
